import React, { FunctionComponent } from 'react'
import { Route, Switch } from 'react-router-dom'

import CampaignsList from 'Containers/CampaignsList'
import CreateCampaignForm from 'Containers/CreateCampaignPage'
import CampaignResults from 'Containers/CampaignResults'
import Details from 'Containers/Details'
import ExpiredLinkPage from 'Containers/ui/ExpiredLinkPage'

import AdminProtected from './AdminProtected'
import SettingsComponents from './routes/artistRoutes/SettingsComponents'
import ScheduleCampaignComponents from './routes/artistRoutes/ScheduleCampaignComponents'
import CreateCampaignComponents from './routes/artistRoutes/CreateCampaignComponents'
import ScheduleCampaignRoute from './routes/artistRoutes/ScheduleCampaignRoute'
import SettingsRoute from './routes/artistRoutes/SettingsRoute'
import CreateCampaignRoute from './routes/artistRoutes/CreateCampaignRoute'

import {
  campaignsList,
  campaignResults,
  details,
  errors,
  login,
  create,
  scheduleCampaign,
  settings,
  createCampaign,
  admin,
  analytics,
} from './routes'
import { UserComponentsProps } from './props'

const ArtistComponents: FunctionComponent<UserComponentsProps> = ({ user }) => (
  <>
    <Switch>
      <Route
        path={[
          '/',
          campaignsList,
          create,
          login,
          `${campaignsList}${campaignResults}/:campaignID`,
          `${campaignsList}${details}/:campaignID`,
        ]}
        exact
      >
        <Switch>
          <Route component={CampaignsList} exact path="/" />
          <Route component={CampaignsList} exact path={campaignsList} />
          <Route component={CreateCampaignForm} exact path={create} />
          <Route component={CampaignsList} path={login} />
          <Route
            component={CampaignResults}
            exact
            path={`${campaignsList}${campaignResults}/:campaignID`}
          />
          <Route
            component={Details}
            exact
            path={`${campaignsList}${details}/:campaignID`}
          />
        </Switch>
      </Route>
      <Route path={`${campaignsList}${scheduleCampaign}`}>
        <ScheduleCampaignRoute component={ScheduleCampaignComponents} />
      </Route>
      <Route path={[settings]}>
        <SettingsRoute component={SettingsComponents} />
      </Route>
      <Route path={`${campaignsList}${createCampaign}`}>
        <CreateCampaignRoute component={CreateCampaignComponents} />
      </Route>

      <Route component={ExpiredLinkPage} path={errors} />

      <Route path={[admin, analytics]}>
        <AdminProtected user={user} />
      </Route>

      <Route component={CampaignsList} path="*" />
    </Switch>
  </>
)

export default ArtistComponents
